import { ControlledTable } from "Components";
import { MultiFormObjType } from "DataTypes/Form";
import { actionArrType, columnType } from "DataTypes/Table";

export const FormDataObj: MultiFormObjType = {
  id: "practice",
  label: "Problem(s)",
  placeholder: "Select Problem(s)",
  boxType: "multi-select",
  boxSize: 3,
  validatetype: "multi-dropdown",
  readOnly: false,
  dropArr: [
    {
      id: 1,
      label: "Asthma",
      value: 1
    },
    {
      id: 2,
      label: "Hypertension",
      value: 2
    },
    {
      id: 3,
      label: "Daibetes",
      value: 3
    },
  ]
};

export const TableCol: () => columnType[] = () => {
  const Arr: columnType[] = [
    ControlledTable.ColumnData.ProblemNameCol("20%"),
    ControlledTable.ColumnData.CreatedByCol("20%"),
    ControlledTable.ColumnData.CreatedAtCol("20%"),
    ControlledTable.ColumnData.StatusCol("20%"),
    ControlledTable.ColumnData.ActionCol(),
  ];
  return Arr;
};

export interface PreApprovTableDataType {
  id: number | null,
  problemName: string,
  createdby: string,
  createdat: string,
  status: string
}

export const TableData: PreApprovTableDataType[] = [
  {
    id: 1,
    problemName: "Asthma",
    createdby: "Emor Admin, PAdmin",
    createdat: "01/06/2026 11:30 AM",
    status: "Waiting for approval"
  },
  {
    id: 2,
    problemName: "Hypertension",
    createdby: "Emor Admin, PAdmin",
    createdat: "01/06/2026 11:30 AM",
    status: "Approved"
  }
]

export const actionArr: (
  handleEditPreApprovedPlan: () => void,
  data: PreApprovTableDataType
) => actionArrType[] = (handleEditPreApprovedPlan, data) => {
  const Arr: actionArrType[] = [
    ControlledTable.ActionData.editAction({
      handleClick: handleEditPreApprovedPlan
    }),
    ...(data.status == "Waiting for approval"
      ? [
        ControlledTable.ActionData.WithdrawAction({
          handleClick: () => console.log("test")
        }),
        ControlledTable.ActionData.SendReminderAction({
          handleClick: () => console.log("test")
        })
      ] : [
        ControlledTable.ActionData.enableDisableAction(
          () => console.log("test"), true
        ),
      ]),
  ];
  return Arr;
};

